export default {
  SPAN_TITLE: 9,
  SPAN_INPUT: 14,
  SPAN_INPUT_PRICE: 6,
  SPAN_SUFFIX: 1
}
